import axios, { AxiosHeaders } from "axios";
import { getGlobalContext, updateGlobalContextTokens } from "../context/global-context-provider";
// Create an instance of axios
const axiosInstance = axios.create({
  withCredentials: true,
});
// Add a request interceptor
axiosInstance.interceptors.request.use((request) => {
  let _bearerToken:string = "";
  let _infToken:string = "";
  let _cdoName:string = "";
  try {
    const globalContext = getGlobalContext();
    _bearerToken = globalContext.GatewayToken || '';
    _infToken = globalContext.InfermedicaToken || '';
    _cdoName = globalContext.CdoName || '';

    if (_bearerToken) {
      (request.headers as AxiosHeaders).set('Authorization', `Bearer ${_bearerToken}`);
    }

    if (_infToken) {
      (request.headers as AxiosHeaders).set('X-Ifa-Token', `${_infToken}`);
    }
  

    if (_cdoName) {
      (request.headers as AxiosHeaders).set('X-CDO-Name', _cdoName);
    }

  } catch (error) {
    console.error("No token was received");
  }
  return request;
});

axiosInstance.interceptors.response.use((response) => {
  const refreshedGatewayToken = response.headers?.['x-refreshed-gateway-token'];
  const refreshedInfermedicaToken = response.headers?.['x-refreshed-infermedica-token'];

  if (refreshedGatewayToken || refreshedInfermedicaToken) {
    updateGlobalContextTokens({
      GatewayToken: refreshedGatewayToken || undefined,
      InfermedicaToken: refreshedInfermedicaToken || undefined
    });

    if (refreshedGatewayToken) {
      sessionStorage.setItem('Bearer', refreshedGatewayToken);
    }
  }

  return response;
});

export default axiosInstance;
